import { apiClient, handleResponse } from './axios';

async function getSkillTitles() {
  try {
    const response = await apiClient.get('/skilltitle');
    const skilltitles = await handleResponse(response);
    return skilltitles;
  } catch (error) {
    return error.response;
  }
}

async function addSkillTitle(body) {
  try {
    const response = await apiClient.post('/skilltitle', body);
    const skilltitles = await handleResponse(response);
    return skilltitles;
  } catch (error) {
    return error.response;
  }
}

async function updateSkillTitles(skilltitleId) {
  try {
    const response = await apiClient.put(`/skilltitle/${skilltitleId}`);
    const skilltitles = await handleResponse(response);
    return skilltitles;
  } catch (error) {
    return error.response;
  }
}

const skillTitleServices = {
  getSkillTitles,
  addSkillTitle,
  updateSkillTitles,
};

export default skillTitleServices;
